import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/app/AuthProvider';
import { DevModeProvider } from '@/app/DevModeContext';
import { queryClient } from '@/app/queryClient';
import { StudioUIProvider } from '@/app/StudioUIContext';
import { TooltipProvider } from '@/shared/ui/Tooltip/Tooltip';

interface AppProvidersProps {
  children: React.ReactNode;
}

const withDevMode = (children: React.ReactNode) => {
  if (import.meta.env.DEV) {
    return <DevModeProvider>{children}</DevModeProvider>;
  }
  return <>{children}</>;
};

/**
 * Orchestrates the application's nested provider tree.
 */
export function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {withDevMode(
        <StudioUIProvider>
          <TooltipProvider delayDuration={400}>
            <AuthProvider>{children}</AuthProvider>
          </TooltipProvider>
        </StudioUIProvider>
      )}
    </QueryClientProvider>
  );
}
